import React from "react";

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 min

/**
 * Compare le BUILD_ID inliné à la compilation (REACT_APP_BUILD_ID) avec celui
 * publié sur `/version.txt`. Polling toutes les 5 min + check à chaque retour
 * d'onglet visible. Retourne `true` une fois qu'un nouveau build est détecté.
 */
export function useBuildVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = React.useState(false);
    const buildId = process.env.REACT_APP_BUILD_ID;

    React.useEffect(() => {
        if (!buildId) return; // dev ou non-injecté → on ne fait rien
        let stopped = false;
        let timer;

        async function check() {
            if (stopped) return;
            try {
                const res = await fetch(`/version.txt?_=${Date.now()}`, {
                    cache: "no-store",
                });
                if (res.ok) {
                    const remote = (await res.text()).trim();
                    if (remote && remote !== buildId) {
                        setUpdateAvailable(true);
                        return; // plus la peine de poller
                    }
                }
            } catch {
                /* offline / 404 → on retentera */
            }
            if (!stopped) timer = setTimeout(check, POLL_INTERVAL_MS);
        }

        timer = setTimeout(check, POLL_INTERVAL_MS);

        function onVisibility() {
            if (document.visibilityState === "visible") check();
        }
        document.addEventListener("visibilitychange", onVisibility);

        return () => {
            stopped = true;
            clearTimeout(timer);
            document.removeEventListener("visibilitychange", onVisibility);
        };
    }, [buildId]);

    return updateAvailable;
}
